<template>
  <Loading v-if="isLoading" :type="1" />
  <div v-else>
    <div class="w-100 d-flex flex-row-reverse">
      <GenericBtnAdd v-if="$user.get().role == 'admin'" @click="addMessage" />
    </div>
    <FormThresholdSection
      id="FormThresholdSection"
      :isShown="show"
      v-on:canceled="close"
      @successed-request="close"
      :action="this.$api.addMessage"
      :softwareId="parseInt(this.id)"
    />
    <!-- Section header-->
    <div class="pl-2">
      <h4 class="font-weight-normal">
        {{ "sections.listThresholdsSection.title" | i18n }}
      </h4>
      <h6 class="text-light font-weight-lighter">
        {{ "sections.listThresholdsSection.subtitle" | i18n }}
      </h6>
    </div>
    <!-- List-->
    <b-table
      v-if="!isLoading"
      name="table"
      class="table hide-scroll text-left text-small mb-0 w-100 table align-middle"
      :items="list"
      :fields="columns"
      sticky-header="200px"
      borderless
      :small="true"
      head-row-variant="transparent"
      tbody-tr-class="test"
      :responsive="true"
    >
      <template v-slot:cell(buttons)="row">
        <b-row class="test">
          <GenericFormUpdate
            v-if="$user.get().role == 'admin'"
            :objectId="row.item.id"
            :modalId="4"
            :softwareId="parseInt(id)"
            border="border-0"
            :hasHover="false"
          />
          <GenericFormDelete
            v-if="canDeleteMessage(row) && $user.get().role == 'admin'"
            :objectId="row.item.id"
            :id="'delete-form-message-' + row.item.id"
            :border="false"
            :deleteFunction="computedDeleteFunction"
            :modalId="'modal-message-' + row.item.id"
          />
        </b-row>
      </template>
    </b-table>
  </div>
</template>
<script>
import FormThresholdSection from "../forms/FormThresholdSection.vue";
import {
  Loading,
  GenericFormUpdate,
  GenericBtnAdd,
  GenericFormDelete
} from "@/components";
/**
 * @description Section qui gère les seuils d'erreur pour un logiciel
 * @author Gabriel Bertrand
 * @author Kevin Dubé
 * @vue-prop {String} id - Id du logiciel
 * @vue-data {Boolean} show - Définit si le modal est affiché ou non
 * @vue-data {Boolean} isLoading - Si la section est en cours de chargement
 * @vue-data {Array} list - Liste des erreurs pour un logiciel
 * @vue-data {Array} columns - Les colonnes à afficher dans la liste des erreurs
 * @vue-computed {Function} computedDeleteFunction - Retourne la fonction de suppression de message
 */
export default {
  name: "ListThresholdsSection",
  components: {
    Loading,
    FormThresholdSection,
    GenericFormUpdate,
    GenericBtnAdd,
    GenericFormDelete
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      isLoading: true,
      list: [],
      columns: [
        {
          key: "code",
          label: this.$i18n.t("sections.listThresholdsSection.code"),
          class: "align-middle"
        },
        {
          key: "seuil_avertissement",
          label: this.$i18n.t("sections.listThresholdsSection.warnings"),
          class: "align-middle"
        },
        {
          key: "seuil_critique",
          label: this.$i18n.t("sections.listThresholdsSection.criticals"),
          class: "align-middle"
        },
        {
          key: "buttons",
          label: ""
        }
      ]
    };
  },
  computed: {
    computedDeleteFunction() {
      return this.$api.deleteMessage;
    }
  },
  methods: {
    /**
     * @description Permet de fermer le modal
     */
    close() {
      this.show = false;
    },
    /**
     * @description Permet d'ouvrir le modal
     */
    addMessage() {
      this.show = true;
    },
    /**
     * @description Méthode qui récupère les types d'erreurs pour un logiciel et les stocke dans la variable «list»
     */
    getErrorList: async function() {
      let response = await this.$api.getSoftwareErrorThresholds(this.id);
      let dataList = response.data.data;
      for (let i = 0; i < dataList.length; i++) {
        Object.assign(dataList[i], {
          button: dataList[i].id
        });
      }
      this.list = dataList;
      this.isLoading = false;
    },
    /**
     * @description Définit si le message peut être supprimé, pour l'instant seuls les administrateurs peuvent le faire
     * @returns {Boolean} Si l'utilisateur peut supprimer le message
     */
    canDeleteMessage() {
      return this.$user.get().role === "admin";
    }
  },
  /**
   * @description Méthode qui appelle la fonction qui récupère la liste des types d'erreur avant que la composante ne soit affichée
   */
  beforeMount() {
    this.getErrorList();
  }
};
</script>

<style lang="scss" scoped>
.hide-scroll::-webkit-scrollbar {
  display: none;
}
</style>
